module.exports = __webpack_public_path__ + "img/shanghai.dbb8f127.jpg";